const stringOperators = [
  { key: "Starts With", value: "startswith" },
  { key: "Ends With", value: "endswith" },
  { key: "Contains", value: "contains" },
  { key: "Equal", value: "equal" },
  { key: "Not Equal", value: "notequal" },
  { key: "In", value: "in" },
  { key: "Not In", value: "notin" },
  { key: "Is Empty", value: "isempty" },
  { key: "Is Not Empty", value: "isnotempty" },
  { key: "Is Null", value: "isnull" },
  { key: "Is Not Null", value: "isnotnull" }
]
const numberOperators = [
  { key: "Equal", value: "equal" },
  { key: "Greater Than Or Equal", value: "greaterthanorequal" },
  { key: "Greater Than", value: "greaterthan" },
  { key: "Less Than", value: "lessthan" },
  { key: "Less Than Or Equal", value: "lessthanorequal" },
  { key: "Between", value: "between" },
  { key: "Not Between", value: "notbetween" },
  { key: "Not Equal", value: "notequal" },
  { key: "In", value: "in" },
  { key: "Not In", value: "notin" },
  { key: "Is Null", value: "isnull" },
  { key: "Is Not Null", value: "isnotnull" }
];
const dateOperators = [
  { key: "Equal", value: "equal" },
  { key: "Greater Than Or Equal", value: "greaterthanorequal" },
  { key: "Greater Than", value: "greaterthan" },
  { key: "Less Than", value: "lessthan" },
  { key: "Less Than Or Equal", value: "lessthanorequal" },
  { key: "Not Equal", value: "notequal" },
  { key: "Is Null", value: "isnull" },
  { key: "Is Not Null", value: "isnotnull" }
];
const dropdownBoolOperators = [
  { key: "Equal", value: "equal" },
  { key: "Not Equal", value: "notequal" },
  { key: "Is Null", value: "isnull" },
  { key: "Is Not Null", value: "isnotnull" }
];

export const fields = [
  {
    dataField: "clusterName",
    dataType: 'string',
    caption: "Cluster Name",
    gridFormat: {
      type: 'fixedPoint',
      precision: 0
    },
    inMainGrid: true,
    isMainGridDefault: true,
    summaryType: 'count',
    // sortOrder: 'asc',
    minWidth: 100,
    fixed: true
  },
  {
    dataField: "propertiesCount",
    dataType: 'number',
    caption: "Units Count",
    format: {
      type: 'fixed',
      decimals: 0,
      useSeparator: true,
      abbreviation: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 0
    },
    inMainGrid: true,
    isMainGridDefault: true,
    // inPinDisplay: true,
    summaryType: 'sum',
    minWidth: 120
    //sortOrder: 'desc'
  },
  // {
  //   dataField: "lastSalePriceSum",
  //   dataType: 'number',
  //   caption: "Sold Volume",
  //   format: {
  //     type: 'money',
  //     decimals: 0
  //   },
  //   gridFormat: {
  //     type: 'currency',
  //     precision: 0
  //   },
  //   inMainGrid: true,
  //   //inPinDisplay: true,
  //   summaryType: 'sum',
  //   minWidth: 100
  // },
  {
    dataField: "marketValue",
    dataType: 'number',
    caption: "Market Value",
    sortOrder: 'desc',
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      useSeparator: true,
      rounding: 10000
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    isMainGridDefault: true,
    inPinDisplay: true,
    summaryType: 'sum',
    minWidth: 100
  },
  {
    dataField: "beds",
    dataType: 'number',
    caption: "Beds",
    format: {
      type: 'fixed',
      decimals: 0,
      useSeparator: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 0 },
      category: 'Indicatives',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 58
  },
  {
    dataField: "fullBaths",
    dataType: 'number',
    caption: "Baths",
    format: {
      type: 'fixed',
      decimals: 0,
      useSeparator: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 0 },
      category: 'Indicatives',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 58
  },
  {
    dataField: "livingAreaSqFt",
    dataType: 'number',
    caption: "Living Area",
    format: {
      type: 'fixed',
      decimals: 0,
      useSeparator: true,
      abbreviation: true,
      rounding: 500
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 0
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 0 },
      category: 'Indicatives',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 85
  },
  {
    dataField: "stories",
    dataType: 'number',
    caption: "Stories",
    format: {
      type: 'fixed',
      decimals: 2,
      useSeparator: true,
      abbreviation: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 2
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 2 },
      category: 'Indicatives',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 85
  },
  {
    dataField: "lotSizeAcres",
    dataType: 'number',
    caption: "Lot Size Acres",
    format: {
      type: 'fixed',
      decimals: 4,
      useSeparator: true,
      abbreviation: true,
      rounding: 500
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 4
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 4 },
      category: 'Indicatives',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 85
  },
  {
    dataField: "yearBuilt",
    dataType: 'number',
    caption: "Year Built",
    format: {
      type: 'fixed',
      decimals: 0,
      useSeparator: false,
      rounding: 10
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      category: 'Indicatives',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 80
  },
  {
    dataField: "propertyType",
    dataType: 'string',
    caption: "Property Type",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      operators: dropdownBoolOperators,
      category: 'Indicatives'
    },
    inPinDisplay: true
  },
  {
    dataField: "propertySubtype",
    dataType: 'string',
    caption: "Property Subtype",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      operators: dropdownBoolOperators,
      category: 'Indicatives'
    }
  },
  {
    dataField: "descriptiveBuyBoxFit",
    dataType: 'boolean',
    caption: "Descriptive Buy Box Fit",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'boolean',
      category: 'Indicatives',
      operators: dropdownBoolOperators
    },
  },
  {
    dataField: "address",
    dataType: 'string',
    caption: "Street",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators,
      disableAnyOf: true
    }
  },
  {
    dataField: "city",
    dataType: 'string',
    caption: "City",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "state",
    dataType: 'string',
    caption: "State",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "zipCode",
    dataType: 'string',
    caption: "Zipcode",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "CensusTractGeoId",
    dataType: 'string',
    caption: "Census Tract ID",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "FIPS",
    dataType: 'string',
    caption: "FIPS",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "CBSA",
    dataType: 'string',
    caption: "CBSA",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "communityName",
    dataType: 'string',
    caption: "Community Name",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Indicatives',
      operators: stringOperators
    }
  },
  {
    dataField: "asgPropID",
    dataType: 'number',
    caption: "PM ID",
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      category: 'Indicatives',
      operators: numberOperators,
      disableAnyOf: true
    },
    summaryType: 'count',
    minWidth: 85
  },
  {
    dataField: "forSalePrice",
    dataType: 'number',
    caption: "For Sale Price",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 50000
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD' },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 108
  },
  {
    dataField: "forSalePricePerSqFt",
    dataType: 'number',
    caption: "For Sale Price/SqFt",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 10
    },
    gridFormat: {
      type: 'currency',
      precision: 1
    },
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD', precision: 2 },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: false,
    summaryType: 'avg',
    minWidth: 100
  },
  {
    dataField: "forRentPrice",
    dataType: 'number',
    caption: "For Rent Price",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 100
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD' },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 90
  },
  {
    dataField: "forRentPricePerSqFt",
    dataType: 'number',
    caption: "For Rent Price/SqFt",
    format: {
      type: 'money',
      decimals: 2,
      rounding: .1
    },
    gridFormat: {
      type: 'currency',
      precision: 2
    },
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD', precision: 2 },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: false,
    summaryType: 'avg',
    minWidth: 90
  },
  {
    dataField: "status",
    dataType: 'string',
    caption: "Status",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      operators: dropdownBoolOperators,
      category: 'Transaction'
    }
  },
  {
    dataField: "statusDate",
    dataType: "date",
    caption: "Status Date",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: "date",
      category: "Transaction",
      operators: dateOperators
    }
  },
  {
    dataField: "lastSalePrice",
    dataType: "number",
    caption: "Last Sale Price",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 50000
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: "number",
      format: { type: 'currency', currency: 'USD' },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 108
  },
  {
    dataField: "lastSaleDate",
    dataType: "date",
    caption: "Last Sale Date",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: "date",
      category: 'Transaction',
      operators: dateOperators
    }
  },
  {
    dataField: "lastRent",
    dataType: "number",
    caption: "Last Rent",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 100
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: "number",
      format: { type: 'currency', currency: 'USD' },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 80
  },
  {
    dataField: "lastRentDate",
    dataType: "date",
    caption: "Last Rent Date",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: "date",
      category: 'Transaction',
      operators: dateOperators
    }
  },
  {
    dataField: "isRecentFlip",
    dataType: 'boolean',
    caption: "Recent Flip",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'boolean',
      category: 'Transaction',
      operators: dropdownBoolOperators
    }
  },


  {
    dataField: "modelRent",
    dataType: 'number',
    caption: "Model Rent",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 100
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD' },
      category: 'Valuation',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 80
  },
  {
    dataField: "lastTaxAmount",
    dataType: 'number',
    caption: "Last Tax Amount",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 100
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD' },
      category: 'Transaction',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 80
  },
  {
    dataField: "avmValue",
    dataType: 'number',
    caption: "AVM",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 50000
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD' },
      category: 'Valuation',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 90
  },
  {
    dataField: "forSalePricePctOfAVM",
    dataType: 'number',
    caption: "% of AVM",
    format: {
      type: 'percent',
      decimals: 0,
      abbreviation: true,
      rounding: .05
    },
    gridFormat: {
      type: 'percent',
      precision: 1
    },
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'percent', precision: 1 },
      category: 'Valuation',
      operators: numberOperators
    },
    inPinDisplay: false,
    summaryType: 'avg'
  },
  {
    dataField: "transactionOpportunityId",
    dataType: 'number',
    caption: "Transaction Opportunity ID",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'number',
      category: 'Valuation',
      operators: numberOperators,
      disableAnyOf: true
    }
  },
  {
    dataField: "uwChannel",
    dataType: 'string',
    caption: "Opportunity Channel",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Valuation',
      operators: dropdownBoolOperators
    }
  },
  {
    dataField: "opportunityStatus",
    dataType: 'string',
    caption: "Opportunity Status",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Valuation',
      operators: dropdownBoolOperators
    }
  },
  {
    dataField: "postAcqTaskStatus",
    dataType: 'string',
    caption: "Post-Acq Task Status",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Valuation',
      operators: dropdownBoolOperators
    }
  },
  {
    dataField: "capRate",
    dataType: 'number',
    caption: "Cap Rate",
    format: {
      type: 'percent',
      decimals: 1,
      useSeparator: true
    },
    gridFormat: {
      type: 'percent',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'percent', precision: 1 },
      category: 'Valuation',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 75
  },
  {
    dataField: "medianIncome",
    dataType: 'number',
    caption: "AMI",
    format: {
      type: 'money',
      decimals: 0,
      abbreviation: true,
      rounding: 10000
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'currency', currency: 'USD' },
      category: 'Market',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 85
  },
  {
    dataField: "schoolScore",
    dataType: 'number',
    caption: "School Score",
    format: {
      type: 'fixed',
      decimals: 1,
      useSeparator: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 1 },
      category: 'Market',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 90
  },
  {
    dataField: "unemploymentRate",
    dataType: 'number',
    caption: "Unemp Rate",
    format: {
      type: 'fixed',
      decimals: 1,
      useSeparator: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'fixedPoint', precision: 1 },
      category: 'Market',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 80
  },
  // { // 08/24 Removed while crimeIndex data is null
  //   dataField: "crimeIndex",
  //   dataType: 'number',
  //   caption: "Crime Index",
  //   format: {
  //     type: 'fixed',
  //     decimals: 0,
  //     useSeparator: true
  //   },
  //   gridFormat: {
  //     type: 'fixedPoint',
  //     precision: 0
  //   },
  //   inMainGrid: true,
  //   filterBuilder: {
  //     enabled: true,
  //     type: 'number',
  //     format: { type: 'fixedPoint', precision: 0 },
  //     category: 'Market',
  //     operators: numberOperators
  //   },
  //   inPinDisplay: true,
  //   summaryType: 'avg',
  //   minWidth: 80
  // },
  {
    dataField: "hpA1Yr",
    dataType: 'number',
    caption: "HPA 12mo",
    format: {
      type: 'percent',
      decimals: 1,
      useSeparator: true,
      rounding: .05
    },
    gridFormat: {
      type: 'percent',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'percent', precision: 1 },
      category: 'Market',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 75
  },
  {
    dataField: "hpA6mo",
    dataType: 'number',
    caption: "HPA 6mo",
    format: {
      type: 'percent',
      decimals: 1,
      useSeparator: true,
      rounding: .05
    },
    gridFormat: {
      type: 'percent',
      precision: 1
    },
    inMainGrid: true,
    isMainGridDefault: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'percent', precision: 1 },
      category: 'Market',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 75
  },
  {
    dataField: "hpA2Yr",
    dataType: 'number',
    caption: "HPA 24mo",
    format: {
      type: 'percent',
      decimals: 1,
      useSeparator: true,
      rounding: .05
    },
    gridFormat: {
      type: 'percent',
      precision: 1
    },
    inMainGrid: true,
    filterBuilder: {
      enabled: true,
      type: 'number',
      format: { type: 'percent', precision: 1 },
      category: 'Market',
      operators: numberOperators
    },
    inPinDisplay: true,
    summaryType: 'avg',
    minWidth: 75
  },
  {
    dataField: "forSalePriceSum",
    dataType: 'number',
    caption: "For Sale Volume",
    format: {
      type: 'money',
      decimals: 0
    },
    gridFormat: {
      type: 'currency',
      precision: 0
    },
    inMainGrid: false,
    inPinDisplay: false,
    summaryType: 'sum',
    minWidth: 100
  },
  {
    dataField: "amherstDemographicCategory",
    dataType: 'number',
    caption: "Demographic v1",
    format: {
      type: 'fixed',
      decimals: 1,
      abbreviation: true
    },
    gridFormat: {
      type: 'fixedPoint',
      precision: 1
    },
    inMainGrid: false,
    inPinDisplay: false,
    summaryType: 'avg',
    minWidth: 100
  },
  {
    dataField: "gemstone",
    dataType: 'string',
    caption: "Gemstone",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Market',
      operators: stringOperators
    },
    inPinDisplay: true
  },
  {
    dataField: "amherstDemographicCluster_v2",
    dataType: 'string',
    caption: "Demographic Cluster",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Market',
      operators: stringOperators
    },
    inPinDisplay: true
  },
  {
    dataField: "isInOpportunityZone",
    dataType: 'boolean',
    caption: "Opportunity Zone",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'boolean',
      category: 'Market',
      operators: dropdownBoolOperators
    }
  },


  {
    dataField: "isAmherstManaged",
    dataType: 'boolean',
    caption: "Amherst Property",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'boolean',
      category: 'Amherst',
      operators: dropdownBoolOperators
    }
  },
  {
    dataField: "amherstPropertyID",
    dataType: 'number',
    caption: "Amherst Property ID",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'number',
      category: 'Amherst',
      operators: numberOperators
    }
  },
  {
    dataField: "amherstRegion",
    dataType: "string",
    caption: "Amherst Region",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: "string",
      category: "Amherst",
      operators: stringOperators
    }
  },
  {
    dataField: "ownerType",
    dataType: 'string',
    caption: "Owner Type",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Amherst',
      operators: dropdownBoolOperators
    }
  },
  {
    dataField: "ownerName",
    dataType: 'string',
    caption: "Owner Name",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Amherst',
      operators: stringOperators,
      disableAnyOf: true
    }
  },
  {
    dataField: "crmStatus",
    dataType: 'string',
    caption: "CRM Status",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'string',
      category: 'Amherst',
      operators: dropdownBoolOperators
    }
  },
  {
    dataField: "isProspect",
    dataType: 'boolean',
    caption: "Prospect",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: 'boolean',
      category: 'Amherst',
      operators: dropdownBoolOperators
    },
  },
  {
    dataField: "customPortfolio",
    dataType: 'string',
    caption: "Custom Tag",
    inMainGrid: false,
    filterBuilder: {
      enabled: true,
      type: "string",
      category: "Amherst",
      operators: stringOperators
    }
  }
];

export const gridFieldIndex = {
  clusterName: 0,
  asgPropID: 1,
  propertiesCount: 2,
  marketValue: 3,
  beds: 4,
  fullBaths: 5,
  livingAreaSqFt: 6,
  stories: 7,
  lotSizeAcres: 8,
  yearBuilt: 9,
  forSalePrice: 10,
  forRentPrice: 11,
  lastSalePrice: 12,
  lastRent: 13,
  modelRent: 14,
  lastTaxAmount: 15,
  avmValue: 16,
  medianIncome: 17,
  schoolScore: 18,
  unemploymentRate: 19,
  crimeIndex: 20,
  capRate: 21,
  hpA2Yr: 22,
  hpA1Yr: 23,
  hpA6mo: 24,
  __placeholder__: 25
}
